"use client";

import { LoadingSpinner } from "@/app/[lang]/_components/LoadingSpinner";
import type { Locale } from "@borderless/database/enums";
import { cn } from "@borderless/ui/lib/utils";
import { useSearchParams } from "next/navigation";
import { Suspense, useState, type FC } from "react";
import { setStoryLangAndRedirect } from "./set-story-lang-and-redirect";
type StoryLangButtonProps = {
  lang: Locale;
  pathname: string;
  children: React.ReactNode;
  className?: string;
};

export const StoryLangButton: FC<StoryLangButtonProps> = (props) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <StoryLangButtonContent {...props} />
    </Suspense>
  );
};

const StoryLangButtonContent: FC<StoryLangButtonProps> = (props) => {
  const searchParams = useSearchParams();
  const [redirectingTo, setRedirectingTo] = useState<Locale | null>(null);

  return (
    <button
      onClick={async () => {
        setRedirectingTo(props.lang);
        await setStoryLangAndRedirect.bind(null, {
          lang: props.lang,
          pathname: props.pathname,
          searchParams,
        })();
      }}
      className={cn(
        "flex items-center justify-between gap-2 text-start",
        props.className,
      )}
    >
      {redirectingTo === props.lang && (
        <LoadingSpinner backgroundText="x" className="block h-4 w-4 shrink-0" />
      )}
      {props.children}
    </button>
  );
};
